export const clientTypes = {
  buyer: 'buyer',
  coBuyer: 'coBuyer',
};
